import API_URLS from "constants/apis.url";

import { getRequest, postRequest, putRequest } from "./api";

const ANOMALY_URL = API_URLS.activeAnomalyURL;
const ANOMALY_LIST_URL = API_URLS.anomalyListURL;

export const getActiveInsight = () => getRequest(`${ANOMALY_URL}?active=true`);

export const getInsightList = () => getRequest(`${ANOMALY_LIST_URL}`);

export const updateInsight = async payload => await putRequest(`${ANOMALY_LIST_URL}/${payload.Id}`, payload);

export const updateAllInsight = async payload => await postRequest(`${ANOMALY_LIST_URL}`, payload);

export const getHistoryInsight = () => getRequest(`${ANOMALY_URL}`);
